import { useMutation } from '@tanstack/react-query';
import axios from '@/lib/axios';
import { TeamPurchaseOrderPhase, Workspace } from '@/hooks/api/models';

/**
 * 0280. チーム発注フェーズ名編集
 * [PUT] /workspaces/:identifier/teams/:team_id/team_purchase_order_phases/:phase_id
 */
type Props = {
  identifier: string;
  team_id: number;
  phase_id: number;
  label: string;
};
export const updateTeamPurchaseOrderPhases = (props: Props): Promise<TeamPurchaseOrderPhase> => {
  return axios.put(`/api/workspaces/${props.identifier}/teams/${props.team_id}/team_purchase_order_phases/${props.phase_id}`, props);
};

export const useUpdateTeamPurchaseOrderPhases = () => {
  return useMutation({
    mutationFn: updateTeamPurchaseOrderPhases,
  });
};
